import { render, staticRenderFns } from "./ProductSettingsForm.vue?vue&type=template&id=2c7de7a1&scoped=true&"
import script from "./ProductSettingsForm.vue?vue&type=script&lang=ts&"
export * from "./ProductSettingsForm.vue?vue&type=script&lang=ts&"
import style0 from "./ProductSettingsForm.vue?vue&type=style&index=0&id=2c7de7a1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7de7a1",
  null
  
)

export default component.exports